import request from '@/utils/request'

// 경로 가져오기
export const getRouters = (empRoleDeptId) => {
  return request({
    url: `/routers/${empRoleDeptId}`,
    method: 'get'
  })
}